import React, { useEffect } from "react";
import Button from "react-bootstrap/Button";
import './Landing/Landing.css';
import { useHistory } from "react-router-dom";
import Icon from 'supercons';

function Landing() {

  const history = useHistory();
  
  useEffect(() => {
    if(window.localStorage.getItem("authUser") !== null)
    {
    const isLoggedIn = window.localStorage.getItem("authUser") ? true : false;
    if(isLoggedIn)
    {
      history.push("/home");
    }
  }
    
  });

  function onClick()
    {
    history.push("/signup");
    }

    return (
      <div className="App container-fluid">

        <div>
          <div className="container">
            <div className="row">
              <div className="col-md-4">
              <img className="hearts" alt='couple' src='couple.jpg' />
              </div>
               <div className="col-md-4 front-text" >
                They say love is all about finding that special person at the right place and at the right time. 
              </div>
              <div className="col-md-4">
              <img className="hearts" alt='hearts' src='hearts.png' />
                </div>
            </div>
            <div className="row">
  
            <div className="col-md-7 front-text">
             We believe that the place is Georgetown and the time is now. We match you with that special someone using our compatibility test that
             takes into account the whole person and from a pool of only Georgetown students.
            
             </div>
            <div className="col-md-4 front-text">
           
            </div>
            </div>
            <div className="row">     
            <div className="col-md-8"><img className="hearts" alt='gtown' src='gtown.jpg' /></div>
            
            <div className="col-md-4 front-text font-align">
            Curious? Join us Today
           <Button onClick={onClick} block size="lg" type="submit" ><Icon glyph="door-enter" size={32} /> Sign up</Button> 
              </div> 
          
            </div>
          </div>
  
        </div>
 
      </div>
    );
  }
  
  export default Landing;
  